import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTheme } from 'styled-components';

import SharingDialog from 'Workspace/components/SharingDialog';
import projectServiceShape from 'services/types/projectService';
import enhanceWithServices from 'hocs/enhanceWithServices';

import { StackWrapper } from './styles';

function ProjectAvatarStack({ projectId, theme, projectService, hideButton }) {
  const [collaborators, setCollaborators] = useState({});
  useEffect(() => {
    async function getCollaborators() {
      const response = await projectService.getProjectCollaboratorSummary(projectId);
      setCollaborators(response);
    }

    getCollaborators();
  }, [projectService, projectId]);

  const handleNoReduxPermissionGrant = async (id, type, refId, permissionLevel) => {
    await projectService.projectGrantPermission(id, type, refId, permissionLevel);
    const response = await projectService.getProjectCollaboratorSummary(projectId);
    setCollaborators(response);
  };

  const handlePermissionRevoke = async (account) => {
    await projectService.projectRevokePermission(account.id, account.type, projectId);
    const response = await projectService.getProjectCollaboratorSummary(projectId);
    setCollaborators(response);
  };

  return (
    <StackWrapper>
      <SharingDialog
        avatarBorderColor={theme['color.surface']}
        sharedWith={collaborators}
        refId={projectId}
        handleDelete={handlePermissionRevoke}
        grantPermissionNoStoreCallback={handleNoReduxPermissionGrant}
        hideButton={hideButton}
      />
    </StackWrapper>
  );
}

ProjectAvatarStack.propTypes = {
  projectId: PropTypes.string,
  theme: PropTypes.object,
  projectService: projectServiceShape,
  hideButton: PropTypes.bool,
};

export default compose(
  enhanceWithServices,
  withTheme,
)(ProjectAvatarStack);
